document.addEventListener('DOMContentLoaded', function() {
  const blogHeroContent = document.querySelector('.blog-post-hero__content');
  const blogHeroTitle = document.querySelector('.blog-post-hero__title');


  // Función para ajustar el título del blog post
  function adjustBlogTitle() {
    if (blogHeroContent && blogHeroTitle) {
      // Obtener la altura disponible para el título
      const contentRect = blogHeroContent.getBoundingClientRect();
      const metaElement = blogHeroContent.querySelector('.blog-post-hero__meta');
      
      // Calcular el espacio disponible para el título
      let availableHeight = contentRect.height;
      if (metaElement) {
        const metaRect = metaElement.getBoundingClientRect();
        availableHeight -= metaRect.height;
        // Restar un poco más para el espacio entre meta y título
        availableHeight -= 20;
      }
      
      // Establecer un número máximo de líneas basado en el espacio disponible
      const lineHeight = parseInt(window.getComputedStyle(blogHeroTitle).lineHeight) || 1.2 * parseInt(window.getComputedStyle(blogHeroTitle).fontSize);
      const maxLines = Math.floor(availableHeight / lineHeight);
      
      // Aplicar el límite de líneas
      if (maxLines > 0) {
        // Usar setAttribute para evitar errores de TypeScript
        blogHeroTitle.setAttribute('style', `
          -webkit-line-clamp: ${maxLines};
          max-height: ${maxLines * lineHeight}px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        `);
        console.log(`Ajustando título a ${maxLines} líneas (${maxLines * lineHeight}px)`);
      }
    }
  }
  
  // Comprobar si estamos en dispositivo móvil (max-width: 768px)
  function isMobile() {
    return window.innerWidth <= 768;
  }
  
  // Ajustar el título solo en dispositivos móviles
  if (blogHeroContent && blogHeroTitle && isMobile()) {
    // Ejecutar ajuste inmediatamente solo en móviles
    adjustBlogTitle();
    
    // Esperar a que las fuentes se carguen para un cálculo más preciso
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (isMobile()) adjustBlogTitle();
      });
    } else {
      // Fallback para navegadores que no soportan document.fonts
      setTimeout(() => {
        if (isMobile()) adjustBlogTitle();
      }, 500);
    }
    
    // Ajustar el título cuando cambie el tamaño de la ventana (solo en móviles)
    window.addEventListener('resize', () => {
      if (isMobile()) adjustBlogTitle();
    });
    
    // Ajustar el título cuando se carguen las imágenes (solo en móviles)
    const heroImage = document.querySelector('.blog-post-hero__image');
    if (heroImage) {
      heroImage.addEventListener('load', () => {
        if (isMobile()) adjustBlogTitle();
      });
    }
    
    // Ejecutar ajuste adicional después de un tiempo para asegurar que todo esté cargado (solo en móviles)
    setTimeout(() => {
      if (isMobile()) adjustBlogTitle();
    }, 1000);
  }
});
